import { TranslationObject, VehiclePart } from '@monkvision/types';

/**
 * The translated labels for each vehicle part available in the SDK.
 */
export const vehiclePartLabels: Record<VehiclePart, TranslationObject> = {
  [VehiclePart.IGNORE]: {
    en: 'IGNORE',
    ro: 'IGNORĂ',
    pl: 'IGNORUJ',
    da: 'IGNORER',
    sv: 'IGNORERA',
    es: 'IGNORAR',
    pt: 'IGNORAR',
    fr: 'IGNORE',
    de: 'IGNORE',
    nl: 'IGNORE',
    it: 'IGNORE',
  },
  [VehiclePart.BUMPER_BACK]: {
    en: 'Rear Bumper',
    ro: 'Bara spate',
    pl: 'Tylny zderzak',
    da: 'Bagerste kofanger',
    sv: 'Bakre stötfångare',
    es: 'Parachoques trasero',
    pt: 'Para-choque traseiro',
    fr: 'Pare-chocs arrière',
    de: 'Hintere Stoßstange',
    nl: 'Achterbumper',
    it: 'Paraurti posteriore',
  },
  [VehiclePart.BUMPER_FRONT]: {
    en: 'Front Bumper',
    ro: 'Bara față',
    pl: 'Przedni zderzak',
    da: 'Forreste kofanger',
    sv: 'Framstötfångare',
    es: 'Parachoques delantero',
    pt: 'Para-choque dianteiro',
    fr: 'Pare-chocs avant',
    de: 'Vordere Stoßstange',
    nl: 'Voorbumper',
    it: 'Paraurti anteriore',
  },
  [VehiclePart.DOOR_BACK_LEFT]: {
    en: 'Rear Door Left',
    ro: 'Ușa din spate, partea stângă',
    pl: 'Lewe drzwi tylne',
    da: 'Bagdør, venstre',
    sv: 'Vänster bakdörr',
    es: 'Puerta trasera izquierda',
    pt: 'Porta Traseira Esquerda',
    fr: 'Portière arrière gauche',
    de: 'Tür hinten links',
    nl: 'Achterdeur links',
    it: 'Porta posteriore sinistra',
  },
  [VehiclePart.DOOR_BACK_RIGHT]: {
    en: 'Rear Door Right',
    ro: 'Ușă spate dreapta',
    pl: 'Prawy tylny drzwi',
    da: 'Højre bagdør',
    sv: 'Höger bakdörr',
    es: 'Puerta trasera derecha',
    pt: 'Porta traseira direita',
    fr: 'Portière arrière droite',
    de: 'Tür hinten rechts',
    nl: 'Achterdeur rechts',
    it: 'Porta posteriore destra',
  },
  [VehiclePart.DOOR_FRONT_LEFT]: {
    en: 'Front Door Left',
    ro: 'Ușă față, partea stângă',
    pl: 'Lewe drzwi przednie',
    da: 'Venstre fordør',
    sv: 'Framdörr vänster',
    es: 'Puerta delantera izquierda',
    pt: 'Porta dianteira esquerda',
    fr: 'Portière avant gauche',
    de: 'Tür vorne links',
    nl: 'Voordeur links',
    it: 'Porta anteriore sinistra',
  },
  [VehiclePart.DOOR_FRONT_RIGHT]: {
    en: 'Front Door Right',
    ro: 'Ușă față, partea dreaptă',
    pl: 'Prawy przedni drzwi',
    da: 'Højre fordør',
    sv: 'Framdörr, höger',
    es: 'Puerta delantera derecha',
    pt: 'Porta dianteira direita',
    fr: 'Portière avant droite',
    de: 'Tür vorne rechts',
    nl: 'Voordeur rechts',
    it: 'Porta anteriore destra',
  },
  [VehiclePart.FENDER_BACK_LEFT]: {
    en: 'Rear Fender Left',
    ro: 'Aripă spate stânga',
    pl: 'Lewy błotnik tylny',
    da: 'Bagskærm venstre',
    sv: 'Bakre skärm vänster',
    es: 'Guardabarros trasero izquierdo',
    pt: 'Para-lama Traseiro Esquerdo',
    fr: 'Aile arrière gauche',
    de: 'Kotflügel hinten links',
    nl: 'Achterkant linker spatbord',
    it: 'Parafango posteriore sinistro',
  },
  [VehiclePart.FENDER_BACK_RIGHT]: {
    en: 'Rear Fender Right',
    ro: 'Aripă spate dreapta',
    pl: 'Prawy błotnik tylny',
    da: 'Bagskærm, højre',
    sv: 'Höger bakskärm',
    es: 'Guardabarros trasero derecho',
    pt: 'Para-lama Traseiro Direito',
    fr: 'Aile arrière droite',
    de: 'Kotflügel hinten rechts',
    nl: 'Achterkant rechter spatbord',
    it: 'Parafango posteriore destro',
  },
  [VehiclePart.FENDER_FRONT_LEFT]: {
    en: 'Front Fender Left',
    ro: 'Aripă față, partea stângă',
    pl: 'Lewy błotnik przedni',
    da: 'Forreste skærm, venstre',
    sv: 'Framskärm vänster',
    es: 'Guardabarros delantero izquierdo',
    pt: 'Para-lama dianteiro esquerdo',
    fr: 'Aile avant gauche',
    de: 'Linker vorderer Kotflügel',
    nl: 'Voorste linker spatbord',
    it: 'Parafango anteriore sinistro',
  },
  [VehiclePart.FENDER_FRONT_RIGHT]: {
    en: 'Front Fender Right',
    ro: 'Aripă față, partea dreaptă',
    pl: 'Prawy błotnik przedni',
    da: 'Forreste skærm, højre side',
    sv: 'Framskärm, höger',
    es: 'Guardabarros delantero derecho',
    pt: 'Para-lama dianteiro direito',
    fr: 'Aile avant droite',
    de: 'Rechter vorderer Flügel',
    nl: 'Voorste rechter spatbord',
    it: 'Parafango anteriore destro',
  },
  [VehiclePart.FOG_LIGHT_BACK_LEFT]: {
    en: 'Rear Fog Light Left',
    ro: 'Lampa de ceață spate, partea stângă',
    pl: 'Lewe światło przeciwmgielne',
    da: 'Baglygte, venstre',
    sv: 'Bakre dimljus vänster',
    es: 'Luz antiniebla trasera izquierda',
    pt: 'Luz de Nevoeiro Traseira Esquerda',
    fr: 'Phare anti-brouillard arrière gauche',
    de: 'Nebelscheinwerfer hinten links',
    nl: 'Achterste linker mistlamp',
    it: 'Faro antinebbia posteriore sinistro',
  },
  [VehiclePart.FOG_LIGHT_BACK_RIGHT]: {
    en: 'Rear Fog Light Right',
    ro: 'Lampa de ceață spate, dreapta',
    pl: 'Prawa tylna lampa przeciwmgielna',
    da: 'Baglygte, højre side',
    sv: 'Bakre dimljus, höger',
    es: 'Luz antiniebla trasera derecha',
    pt: 'Luz de Nevoeiro Traseira (Lado Direito)',
    fr: 'Phare anti-brouillard arrière droit',
    de: 'Nebelscheinwerfer hinten rechts',
    nl: 'Achterste rechter mistlamp',
    it: 'Faro antinebbia posteriore destro',
  },
  [VehiclePart.FOG_LIGHT_FRONT_LEFT]: {
    en: 'Front Fog Light Left',
    ro: 'Far de ceață față, partea stângă',
    pl: 'Lewy reflektor przeciwmgielny',
    da: 'Forreste tågeforlygte, venstre',
    sv: 'Framre dimljus, vänster',
    es: 'Luz antiniebla delantera izquierda',
    pt: 'Luz de Neblina Dianteira Esquerda',
    fr: 'Phare anti-brouillard avant gauche',
    de: 'Nebelscheinwerfer vorne links',
    nl: 'Voorste linker mistlamp',
    it: 'Faro antinebbia anteriore sinistro',
  },
  [VehiclePart.FOG_LIGHT_FRONT_RIGHT]: {
    en: 'Front Fog Light Right',
    ro: 'Far de ceață față, partea dreaptă',
    pl: 'Prawy reflektor przeciwmgielny',
    da: 'Forreste tågeforlygte, højre',
    sv: 'Framre dimljus, höger',
    es: 'Luz antiniebla delantera derecha',
    pt: 'Luz de Neblina Dianteira, Lado Direito',
    fr: 'Phare anti-brouillard avant droit',
    de: 'Nebelscheinwerfer vorne rechts',
    nl: 'Voorste rechter mistlamp',
    it: 'Faro antinebbia anteriore destro',
  },
  [VehiclePart.GRILL]: {
    en: 'Grill',
    ro: 'Grilă',
    pl: 'Kratka',
    da: 'Grill',
    sv: 'Grill',
    es: 'Rejilla',
    pt: 'Grade dianteira',
    fr: 'Grille',
    de: 'Gitter',
    nl: 'Grill',
    it: 'Griglia',
  },
  [VehiclePart.GRILL_LOW]: {
    en: 'Grill Low',
    ro: 'Grilă joasă',
    pl: 'Dolny grill',
    da: 'Lav grill',
    sv: 'Låg grill',
    es: 'Parte inferior de la parrilla',
    pt: 'Grelha inferior',
    fr: 'Grille bas',
    de: 'Gitter unten',
    nl: 'Lage grill',
    it: 'Griglia bassa',
  },
  [VehiclePart.GRILL_RADIATOR]: {
    en: 'Radiator Grill',
    ro: 'Grilă radiator',
    pl: 'Kratka chłodnicy',
    da: 'Radiatorgitter',
    sv: 'Kylargrill',
    es: 'Rejilla del radiador',
    pt: 'Grade do radiador',
    fr: 'Grille radiateur',
    de: 'Heizkörpergitter',
    nl: 'Radiatorgrill',
    it: 'Griglia del radiatore',
  },
  [VehiclePart.HANDLE_BACK_LEFT]: {
    en: 'Rear Handle Left',
    ro: 'Mâner spate, partea stângă',
    pl: 'Lewy uchwyt tylny',
    da: 'Baghåndtag venstre',
    sv: 'Bakre handtag, vänster',
    es: 'Manija trasera izquierda',
    pt: 'Maçaneta Traseira Esquerda',
    fr: 'Poignée arrière gauche',
    de: 'Griff hinten links',
    nl: 'Achterste linker greep',
    it: 'Maniglia posteriore sinistra',
  },
  [VehiclePart.HANDLE_BACK_RIGHT]: {
    en: 'Rear Handle Right',
    ro: 'Mâner spate, partea dreaptă',
    pl: 'Prawy uchwyt tylny',
    da: 'Højre baghåndtag',
    sv: 'Höger bakre handtag',
    es: 'Manija trasera derecha',
    pt: 'Maçaneta Traseira Direita',
    fr: 'Poignée arrière droite',
    de: 'Griff hinten rechts',
    nl: 'Achterste rechter greep',
    it: 'Maniglia posteriore destra',
  },
  [VehiclePart.HANDLE_FRONT_LEFT]: {
    en: 'Front Handle Left',
    ro: 'Mâner față, partea stângă',
    pl: 'Lewy uchwyt przedni',
    da: 'Forreste håndtag, venstre',
    sv: 'Framhandtag vänster',
    es: 'Manija delantera izquierda',
    pt: 'Manípulo dianteiro esquerdo',
    fr: 'Poignée avant gauche',
    de: 'Griff vorne links',
    nl: 'Voorste linker greep',
    it: 'Maniglia anteriore sinistra',
  },
  [VehiclePart.HANDLE_FRONT_RIGHT]: {
    en: 'Front Handle Right',
    ro: 'Mâner față, partea dreaptă',
    pl: 'Prawy uchwyt przedni',
    da: 'Forreste håndtag, højre',
    sv: 'Framhandtag, höger',
    es: 'Manija delantera derecha',
    pt: 'Maçaneta dianteira direita',
    fr: 'Poignée avant droite',
    de: 'Griff vorne rechts',
    nl: 'Voorste rechter greep',
    it: 'Maniglia anteriore destra',
  },
  [VehiclePart.HEADER_PANEL]: {
    en: 'Header Panel',
    ro: 'Panou de antet',
    pl: 'Panel nagłówkowy',
    da: 'Headerpanel',
    sv: 'Huvudpanel',
    es: 'Panel superior',
    pt: 'Painel do cabeçalho',
    fr: 'Panneau de tête',
    de: 'Kopfleiste',
    nl: 'Headerpaneel',
    it: 'Pannello superiore',
  },
  [VehiclePart.HEAD_LIGHT_LEFT]: {
    en: 'Head Light Left',
    ro: 'Far stânga',
    pl: 'Lewy reflektor',
    da: 'Venstre forlygte',
    sv: 'Vänster strålkastare',
    es: 'Faro delantero izquierdo',
    pt: 'Farol esquerdo',
    fr: 'Phare gauche',
    de: 'Linker Scheinwerfer',
    nl: 'Linker koplamp',
    it: 'Faro sinistro',
  },
  [VehiclePart.HEAD_LIGHT_RIGHT]: {
    en: 'Head Light Right',
    ro: 'Far dreapta',
    pl: 'Prawy reflektor',
    da: 'Forlygte, højre',
    sv: 'Höger strålkastare',
    es: 'Faro delantero derecho',
    pt: 'Farol dianteiro direito',
    fr: 'Phare droit',
    de: 'Rechter Scheinwerfer',
    nl: 'Rechter koplamp',
    it: 'Faro destro',
  },
  [VehiclePart.HOOK]: {
    en: 'Tow Hook',
    ro: 'Cârlig de remorcare',
    pl: 'Haczek do holowania',
    da: 'Trækkrog',
    sv: 'Dragkrok',
    es: 'Gancho de remolque',
    pt: 'Gancho de Reboque',
    fr: 'Crochet de remorquage',
    de: 'Abschlepphaken',
    nl: 'Trekhaak',
    it: 'Gancio di traino',
  },
  [VehiclePart.HUBCAP]: {
    en: 'Hubcap',
    ro: 'Capac jantă',
    pl: 'kołpak',
    da: 'navkapsel',
    sv: 'navkapsel',
    es: 'Tapadera de la rueda',
    pt: 'Calota',
    fr: 'Enjoliveur',
    de: 'Radkappe',
    nl: 'Velgmuts',
    it: 'Copricerchio',
  },
  [VehiclePart.HUBCAP_BACK_LEFT]: {
    en: 'Rear Hubcap Left',
    ro: 'Capac jantă spate, partea stângă',
    pl: 'Lewa tylna osłona piasty',
    da: 'Bageste navkapsel, venstre',
    sv: 'Bakre navkapsel vänster',
    es: 'Tapa de buje trasera izquierda',
    pt: 'Capa de Roda Traseira Esquerda',
    fr: 'Enjoliveur arrière gauche',
    de: 'Radkappe hinten links',
    nl: 'Achterste linker velgmuts',
    it: 'Copricerchio posteriore sinistro',
  },
  [VehiclePart.HUBCAP_BACK_RIGHT]: {
    en: 'Rear Hubcap Right',
    ro: 'Capac jantă spate, partea dreaptă',
    pl: 'Prawa tylna osłona koła',
    da: 'Bageste navkapsel, højre',
    sv: 'Bakre navkapsel, höger',
    es: 'Tapa de buje trasera derecha',
    pt: 'Capa de Roda Traseira, Lado Direito',
    fr: 'Enjoliveur arrière droit',
    de: 'Radkappe hinten rechts',
    nl: 'Achterste rechter velgmuts',
    it: 'Copricerchio posteriore destro',
  },
  [VehiclePart.HUBCAP_FRONT_LEFT]: {
    en: 'Front Hubcap Left',
    ro: 'Capac jantă față, partea stângă',
    pl: 'Lewa osłona piasty przedniej',
    da: 'Forreste navkapsel, venstre',
    sv: 'Framre navkapsel vänster',
    es: 'Tapa de buje delantera izquierda',
    pt: 'Capa de Roda Dianteira Esquerda',
    fr: 'Enjoliveur avant gauche',
    de: 'Radkappe vorne links',
    nl: 'Voorste linker velgmuts',
    it: 'Copricerchio anteriore sinistro',
  },
  [VehiclePart.HUBCAP_FRONT_RIGHT]: {
    en: 'Front Hubcap Right',
    ro: 'Capac jantă față, partea dreaptă',
    pl: 'Prawa osłona piasty przedniej',
    da: 'Forreste navkapsel, højre',
    sv: 'Framre navkapsel, höger',
    es: 'Tapadera delantera derecha',
    pt: 'Capa de Roda Dianteira, Lado Direito',
    fr: 'Enjoliveur avant droite',
    de: 'Radkappe vorne rechts',
    nl: 'Voorste rechter velgmuts',
    it: 'Copricerchio anteriore destro',
  },
  [VehiclePart.INDICATOR_LIGHT_LEFT]: {
    en: 'Indicator Light Left',
    ro: 'Indicator luminos stânga',
    pl: 'Lewy kierunkowskaz',
    da: 'Venstre blinklys',
    sv: 'Vänster blinkers',
    es: 'Luz indicadora izquierda',
    pt: 'Luz de Indicador Esquerda',
    fr: 'Clignotant gauche',
    de: 'Blinkend links',
    nl: 'Linker richtingaanwijzer',
    it: 'Indicator di direzione sinistro',
  },
  [VehiclePart.INDICATOR_LIGHT_RIGHT]: {
    en: 'Indicator Light Right',
    ro: 'Indicator luminos, partea dreaptă',
    pl: 'Prawy kierunkowskaz',
    da: 'Indikatorlys, højre',
    sv: 'Indikatorlampa, höger',
    es: 'Luz indicadora derecha',
    pt: 'Luz de Indicador Direita',
    fr: 'Clignotant droit',
    de: 'Blinkend rechts',
    nl: 'Rechter richtingaanwijzer',
    it: 'Indicator di direzione destro',
  },
  [VehiclePart.LICENSE_PLATE_BACK]: {
    en: 'Rear License Plate',
    ro: 'Placă de înmatriculare spate',
    pl: 'Tylna tablica rejestracyjna',
    da: 'Bagerste nummerplade',
    sv: 'Bakre registreringsskylt',
    es: 'Placa trasera',
    pt: 'Placa Traseira',
    fr: "Plaque d'immatriculation arrière",
    de: 'Autokennzeichen hinten',
    nl: 'Achterste nummerplaat',
    it: 'Targa posteriore',
  },
  [VehiclePart.LICENSE_PLATE_FRONT]: {
    en: 'Front License Plate',
    ro: 'Placă de înmatriculare față',
    pl: 'Przedni numer rejestracyjny',
    da: 'Forreste nummerplade',
    sv: 'Framför registreringsskylt',
    es: 'Placa delantera',
    pt: 'Placa dianteira',
    fr: "Plaque d'immatriculation avant",
    de: 'Autokennzeichen vorne',
    nl: 'Voorste nummerplaat',
    it: 'Targa anteriore',
  },
  [VehiclePart.LOGO]: {
    en: 'Logo',
    ro: 'Logo',
    pl: 'Logo',
    da: 'Logo',
    sv: 'Logotyp',
    es: 'Logotipo',
    pt: 'Logotipo',
    fr: 'Logo',
    de: 'Logo',
    nl: 'Logo',
    it: 'Logo',
  },
  [VehiclePart.MIRROR_LEFT]: {
    en: 'Mirror Left',
    ro: 'Oglindă stânga',
    pl: 'Luster po lewej stronie',
    da: 'Venstre sidespejl',
    sv: 'Vänster backspegel',
    es: 'Espejo izquierdo',
    pt: 'Espelho Esquerdo',
    fr: 'Rétroviseur gauche',
    de: 'Linker Spiegel',
    nl: 'Linker spiegel',
    it: 'Specchietto sinistro',
  },
  [VehiclePart.MIRROR_RIGHT]: {
    en: 'Mirror Right',
    ro: 'Oglindă dreapta',
    pl: 'Luster prawy',
    da: 'Højre sidespejl',
    sv: 'Höger backspegel',
    es: 'Espejo derecho',
    pt: 'Espelho Direito',
    fr: 'Rétroviseur droit',
    de: 'Rechter Spiegel',
    nl: 'Rechter spiegel',
    it: 'Specchietto destro',
  },
  [VehiclePart.MIRROR_SUPPORT]: {
    en: 'Mirror Support',
    ro: 'Suport oglindă',
    pl: 'Podpora lusterka',
    da: 'Spejlstøtte',
    sv: 'Spegelhållare',
    es: 'Soporte del espejo',
    pt: 'Suporte do espelho',
    fr: 'Support de rétroviseur',
    de: 'Spiegelhalterung',
    nl: 'Spiegelsteun',
    it: 'Supporto specchietto',
  },
  [VehiclePart.QUARTER_WINDOW_BACK_LEFT]: {
    en: 'Rear Quarter Window Left',
    ro: 'Geam spate, partea stângă',
    pl: 'Lewe tylne okno',
    da: 'Venstre bagsidevindue',
    sv: 'Bakre sidoruta vänster',
    es: 'Ventana trasera izquierda',
    pt: 'Vidro Traseiro Lateral Esquerdo',
    fr: 'Vitres latérale arrière gauche',
    de: 'Seitenfenster hinten links',
    nl: 'Achterste linker zijkantvenster',
    it: 'Vetro laterale posteriore sinistro',
  },
  [VehiclePart.QUARTER_WINDOW_BACK_RIGHT]: {
    en: 'Rear Quarter Window Right',
    ro: 'Geam spate, partea dreaptă',
    pl: 'Prawa tylna szyba',
    da: 'Højre bagsidevindue',
    sv: 'Höger bakre sidoruta',
    es: 'Ventana trasera lateral derecha',
    pt: 'Vidro Traseiro Lateral Direito',
    fr: 'Vitres latérale arrière droite',
    de: 'Seitenfenster hinten rechts',
    nl: 'Achterste rechter zijkantvenster',
    it: 'Vetro laterale posteriore destro',
  },
  [VehiclePart.QUARTER_WINDOW_FRONT_LEFT]: {
    en: 'Front Quarter Window Left',
    ro: 'Geamul din față, partea stângă',
    pl: 'Lewa przednia szyba boczna',
    da: 'Forreste siderude venstre',
    sv: 'Framre sidoruta vänster',
    es: 'Ventana delantera lateral izquierda',
    pt: 'Vidro da Porta Dianteira Esquerda',
    fr: 'Vitres latérale avant gauche',
    de: 'Seitenfenster vorne links',
    nl: 'Voorste linker zijkantvenster',
    it: 'Vetro laterale anteriore sinistro',
  },
  [VehiclePart.QUARTER_WINDOW_FRONT_RIGHT]: {
    en: 'Front Quarter Window Right',
    ro: 'Geamul din față, partea dreaptă',
    pl: 'Prawa przednia szyba boczna',
    da: 'Forreste siderude, højre',
    sv: 'Framre sidoruta, höger',
    es: 'Ventana delantera lateral derecha',
    pt: 'Vidro Lateral Dianteiro Direito',
    fr: 'Vitres latérale avant droite',
    de: 'Seitenfenster vorne rechts',
    nl: 'Voorste rechter zijkantvenster',
    it: 'Vetro laterale anteriore destro',
  },
  [VehiclePart.ROCKER_PANEL]: {
    en: 'Rocker Panel',
    ro: 'Panou lateral',
    pl: 'Listwa progowa',
    da: 'Sidepanel',
    sv: 'Tröskelplåt',
    es: 'Panel lateral',
    pt: 'Painel lateral',
    fr: 'Bas de caisse',
    de: 'Schweller',
    nl: 'Rockerpaneel',
    it: 'Basamento',
  },
  [VehiclePart.ROCKER_PANEL_LEFT]: {
    en: 'Rocker Panel Left',
    ro: 'Panou lateral stânga',
    pl: 'Lewy próg',
    da: 'Venstre sidepanel',
    sv: 'Vänster tröskel',
    es: 'Panel inferior izquierdo',
    pt: 'Painel Lateral Esquerdo',
    fr: 'Bas de caisse gauche',
    de: 'Schweller links',
    nl: 'Linker rockerpaneel',
    it: 'Basamento sinistro',
  },
  [VehiclePart.ROCKER_PANEL_RIGHT]: {
    en: 'Rocker Panel Right',
    ro: 'Panou lateral drept',
    pl: 'Prawy próg',
    da: 'Højre sidepanel',
    sv: 'Höger tröskel',
    es: 'Panel inferior derecho',
    pt: 'Para-choque Lateral Direito',
    fr: 'Bas de caisse droit',
    de: 'Rechter Schweller',
    nl: 'Rechter rockerpaneel',
    it: 'Basamento destro',
  },
  [VehiclePart.TAIL_LIGHT_CENTER]: {
    en: 'Tail Light Left',
    ro: 'Lampa spate stânga',
    pl: 'Lewe światło tylne',
    da: 'Venstre baglygte',
    sv: 'Vänster baklampa',
    es: 'Luz trasera izquierda',
    pt: 'Lanterna Traseira Esquerda',
    fr: 'Feu arrière centre',
    de: 'Rücklicht Mitte',
    nl: 'Achterlicht midden',
    it: 'Luce posteriore centrale',
  },
  [VehiclePart.TAIL_LIGHT_LEFT]: {
    en: 'Tail Light Left',
    ro: 'Far spate stânga',
    pl: 'Lewe światło tylne',
    da: 'Venstre baglygte',
    sv: 'Vänster baklampa',
    es: 'Luz trasera izquierda',
    pt: 'Lanterna Traseira Esquerda',
    fr: 'Feu arrière gauche',
    de: 'Rücklicht links',
    nl: 'Linker achterlicht',
    it: 'Luce posteriore sinistra',
  },
  [VehiclePart.TAIL_LIGHT_RIGHT]: {
    en: 'Tail Light Right',
    ro: 'Lampa spate dreapta',
    pl: 'Prawa lampa tylna',
    da: 'Højre baglygte',
    sv: 'Höger baklampa',
    es: 'Luz trasera derecha',
    pt: 'Lanterna Traseira Direita',
    fr: 'Feu arrière droite',
    de: 'Rücklicht rechts',
    nl: 'Rechter achterlicht',
    it: 'Luce posteriore destra',
  },
  [VehiclePart.TURN_SIGNAL_FRONT_LATERAL_LEFT]: {
    en: 'Front Turn Signal Lateral Left',
    ro: 'Semnalizator lateral stânga față',
    pl: 'Lewy kierunkowskaz boczny',
    da: 'Forreste blinklys, venstre side',
    sv: 'Framre blinkers, vänster sida',
    es: 'Luz de giro delantera lateral izquierda',
    pt: 'Luz de seta lateral dianteira esquerda',
    fr: 'Clignotant avant latéral gauche',
    de: 'Blinker vorne seitlich links',
    nl: 'Voorste linker zijblinker',
    it: 'Indicatore di direzione anteriore laterale sinistro',
  },
  [VehiclePart.TURN_SIGNAL_FRONT_LATERAL_RIGHT]: {
    en: 'Front Turn Signal Lateral Right',
    ro: 'Semnalizator lateral față, partea dreaptă',
    pl: 'Prawy boczny kierunkowskaz',
    da: 'Forreste blinklys, højre side',
    sv: 'Framre sidoblinkers, höger',
    es: 'Luz de giro delantera lateral derecha',
    pt: 'Luz de seta lateral dianteira direita',
    fr: 'Clignotant avant latéral droit',
    de: 'Blinker vorne seitlich rechts',
    nl: 'Voorste rechter zijblinker',
    it: 'Indicatore di direzione anteriore laterale destro',
  },
  [VehiclePart.WHEEL]: {
    en: 'Wheel',
    ro: 'Roată',
    pl: 'Koło',
    da: 'Hjul',
    sv: 'Hjul',
    es: 'Rueda',
    pt: 'Roda',
    fr: 'Roue',
    de: 'Rad',
    nl: 'Wiel',
    it: 'Ruota',
  },
  [VehiclePart.WHEEL_BACK_LEFT]: {
    en: 'Rear Wheel Left',
    ro: 'Roata spate stânga',
    pl: 'Lewe koło tylne',
    da: 'Bageste venstre hjul',
    sv: 'Vänster bakre hjul',
    es: 'Rueda trasera izquierda',
    pt: 'Roda Traseira Esquerda',
    fr: 'Roue arrière gauche',
    de: 'Linkes Hinterrad',
    nl: 'Achterste linker wiel',
    it: 'Ruota posteriore sinistra',
  },
  [VehiclePart.WHEEL_BACK_RIGHT]: {
    en: 'Rear Wheel Right',
    ro: 'Roata spate dreapta',
    pl: 'Prawy tylny',
    da: 'Bageste hjul, højre',
    sv: 'Höger bakre hjul',
    es: 'Rueda trasera derecha',
    pt: 'Roda Traseira Direita',
    fr: 'Roue arrière droite',
    de: 'Rechtes Hinterrad',
    nl: 'Achterste rechter wiel',
    it: 'Ruota posteriore destra',
  },
  [VehiclePart.WHEEL_FRONT_LEFT]: {
    en: 'Front Wheel Left',
    ro: 'Roata din față, partea stângă',
    pl: 'Lewe przednie koło',
    da: 'Forhjul, venstre',
    sv: 'Framhjul vänster',
    es: 'Rueda delantera izquierda',
    pt: 'Roda dianteira esquerda',
    fr: 'Roue avant gauche',
    de: 'Vorderrad links',
    nl: 'Voorste linker wiel',
    it: 'Ruota anteriore sinistra',
  },
  [VehiclePart.WHEEL_FRONT_RIGHT]: {
    en: 'Front Wheel Right',
    ro: 'Roata din față, partea dreaptă',
    pl: 'Prawy przedni koło',
    da: 'Forhjul, højre',
    sv: 'Framhjul, höger',
    es: 'Rueda delantera derecha',
    pt: 'Roda dianteira direita',
    fr: 'Roue avant droite',
    de: 'Vorderrad rechts',
    nl: 'Voorste rechter wiel',
    it: 'Ruota anteriore destra',
  },
  [VehiclePart.WINDOW_BACK_LEFT]: {
    en: 'Rear Window Left',
    ro: 'Parbriz spate, partea stângă',
    pl: 'Lewa tylna szyba',
    da: 'Bagrude, venstre',
    sv: 'Bakre vänsterfönster',
    es: 'Ventana trasera izquierda',
    pt: 'Janela Traseira Esquerda',
    fr: 'Vitre arrière gauche',
    de: 'Hintere linke Scheibe',
    nl: 'Achterste linker raam',
    it: 'Vetro posteriore sinistro',
  },
  [VehiclePart.WINDOW_BACK_RIGHT]: {
    en: 'Rear Window Right',
    ro: 'Geam spate dreapta',
    pl: 'Prawa tylna szyba',
    da: 'Højre bagrude',
    sv: 'Höger bakre sidoruta',
    es: 'Ventana trasera derecha',
    pt: 'Vidro Traseiro Direito',
    fr: 'Vitre arrière droite',
    de: 'Fenster hinten rechts',
    nl: 'Achterste rechter raam',
    it: 'Vetro posteriore destro',
  },
  [VehiclePart.WINDOW_CORNER_LEFT]: {
    en: 'Corner Window Left',
    ro: 'Colțul ferestrei din stânga',
    pl: 'Lewy narożnik okna',
    da: 'Venstre hjørne af vindue',
    sv: 'Vänster hörn av fönster',
    es: 'Esquina de la ventana izquierda',
    pt: 'Canto da Janela Esquerda',
    fr: "Vitre d'angle gauche",
    de: 'Fenster in der linken Ecke',
    nl: 'Linker hoekraam',
    it: "Vetro d'angolo sinistro",
  },
  [VehiclePart.WINDOW_CORNER_RIGHT]: {
    en: 'Corner Window Right',
    ro: 'Colțul ferestrei din dreapta',
    pl: 'Prawy dolny róg okna',
    da: 'Højre hjørne af vindue',
    sv: 'Högra bakre sidorutan',
    es: 'Esquina de la ventana derecha',
    pt: 'Canto da Janela (Lado Direito)',
    fr: "Vitre d'angle droite",
    de: 'Fenster in der rechten Ecke',
    nl: 'Rechter hoekraam',
    it: "Vetro d'angolo destro",
  },
  [VehiclePart.WINDOW_FRONT_LEFT]: {
    en: 'Front Window Left',
    ro: 'Parbriz, partea stângă',
    pl: 'Lewa przednia szyba',
    da: 'Forreste siderude (venstre)',
    sv: 'Framruta vänster',
    es: 'Ventana delantera izquierda',
    pt: 'Janela Frontal Esquerda',
    fr: 'Vitre avant gauche',
    de: 'Linke vordere Fensterscheibe',
    nl: 'Voorste linker raam',
    it: 'Vetro anteriore sinistro',
  },
  [VehiclePart.WINDOW_FRONT_RIGHT]: {
    en: 'Front Window Right',
    ro: 'Parbriz față, partea dreaptă',
    pl: 'Prawa przednia szyba',
    da: 'Forreste siderude (højre)',
    sv: 'Framruta, höger',
    es: 'Ventana delantera derecha',
    pt: 'Vidro Dianteiro Direito',
    fr: 'Vitre avant droite',
    de: 'Fenster vorne rechts',
    nl: 'Voorste rechter raam',
    it: 'Vetro anteriore destro',
  },
  [VehiclePart.WINDSHIELD_BACK]: {
    en: 'Windshield Back',
    ro: 'Parbriz spate',
    pl: 'Tylna szyba',
    da: 'Forrude, bag',
    sv: 'Vindruta, baksida',
    es: 'Parabrisas trasero',
    pt: 'Para-brisa (parte traseira)',
    fr: 'Pare-brise arrière',
    de: 'Hintere Windschutzscheibe',
    nl: 'Achterste ruit',
    it: 'Parabrezza posteriore',
  },
  [VehiclePart.WINDSHIELD_FRONT]: {
    en: 'Windshield Front',
    ro: 'Parbriz față',
    pl: 'Przednia szyba',
    da: 'Forrude',
    sv: 'Vindruta, fram',
    es: 'Parabrisas delantero',
    pt: 'Para-brisa frontal',
    fr: 'Pare-brise avant',
    de: 'Windschutzscheibe vorne',
    nl: 'Voorruit',
    it: 'Parabrezza anteriore',
  },
  [VehiclePart.WIPER]: {
    en: 'Wiper',
    ro: 'Ștergător',
    pl: 'Wycieraczka',
    da: 'Visker',
    sv: 'Torkare',
    es: 'Limpiaparabrisas',
    pt: 'Limpador de para-brisa',
    fr: 'Essuie-glace',
    de: 'Scheibenwischer',
    nl: 'Scheerwiper',
    it: 'Tergicristallo',
  },
  [VehiclePart.WIPER_BACK]: {
    en: 'Rear Wiper',
    ro: 'Ștergător spate',
    pl: 'Tylna wycieraczka',
    da: 'Bagrudevisker',
    sv: 'Bakre torkare',
    es: 'Limpiaparabrisas trasero',
    pt: 'Limpador traseiro',
    fr: 'Essuie-glace arrière',
    de: 'Heckscheibenwischer',
    nl: 'Achterste scheerwiper',
    it: 'Tergicristallo posteriore',
  },
  [VehiclePart.WIPER_FRONT]: {
    en: 'Front Wiper',
    ro: 'Ștergător față',
    pl: 'Przednia wycieraczka',
    da: 'Forreste vinduesvisker',
    sv: 'Framruta torkare',
    es: 'Limpiaparabrisas delantero',
    pt: 'Limpador dianteiro',
    fr: 'Essuie-glace avant',
    de: 'Scheibenwischer vorne',
    nl: 'Voorste scheerwiper',
    it: 'Tergicristallo anteriore',
  },
  [VehiclePart.FRONT_SPOILER]: {
    en: 'Front Spoiler',
    ro: 'Spoiler frontal',
    pl: 'Przedni spojler',
    da: 'Frontspoiler',
    sv: 'Framspoiler',
    es: 'Spoiler delantero',
    pt: 'Spoiler dianteiro',
    fr: 'Aileron avant',
    de: 'Frontspoiler',
    nl: 'Voorste spoiler',
    it: 'Alerone anteriore',
  },
  [VehiclePart.REAR_SPOILER]: {
    en: 'Rear Spoiler',
    ro: 'Spoiler spate',
    pl: 'Tylny spojler',
    da: 'Bagspoiler',
    sv: 'Bakre spoiler',
    es: 'Spoiler trasero',
    pt: 'Spoiler Traseiro',
    fr: 'Aileron arrière',
    de: 'Heckspoiler',
    nl: 'Achterste spoiler',
    it: 'Alerone posteriore',
  },
  [VehiclePart.HOOD]: {
    en: 'Hood',
    ro: 'Capotă',
    pl: 'Maska',
    da: 'Motorhjelm',
    sv: 'Huv',
    es: 'Capó',
    pt: 'Capô',
    fr: 'Capot',
    de: 'Motorhaube',
    nl: 'Motorkap',
    it: 'Cofano',
  },
  [VehiclePart.PETROL_DOOR]: {
    en: 'Petrol Door',
    ro: 'Ușa rezervorului',
    pl: 'Drzwiczki wlewu paliwa',
    da: 'Benzindæksel',
    sv: 'Tanklock',
    es: 'Puerta del depósito de gasolina',
    pt: 'Tampa do combustível',
    fr: 'Trappe à essence',
    de: 'Tankklappe',
    nl: 'Brandstofklep',
    it: 'Sportello carburante',
  },
  [VehiclePart.PILLAR]: {
    en: 'Pillar',
    ro: 'Stâlp',
    pl: 'Filarek',
    da: 'Søjle',
    sv: 'Stolpe',
    es: 'Pilar',
    pt: 'Pilar',
    fr: 'Carrosserie',
    de: 'Karosserie',
    nl: 'Kolom',
    it: 'Montante',
  },
  [VehiclePart.ROOF]: {
    en: 'Roof',
    ro: 'Acoperiș',
    pl: 'Dach',
    da: 'Tag',
    sv: 'Tak',
    es: 'Techo',
    pt: 'Teto',
    fr: 'Toit',
    de: 'Dach',
    nl: 'Dak',
    it: 'Tetto',
  },
  [VehiclePart.TRUNK]: {
    en: 'Trunk',
    ro: 'Portbagaj',
    pl: 'Bagażnik',
    da: 'bagagerum',
    sv: 'Bagageutrymme',
    es: 'Maletero',
    pt: 'Porta-malas',
    fr: 'Coffre',
    de: 'Kofferraum',
    nl: 'Kofferbak',
    it: 'Bagagliaio',
  },
  [VehiclePart.BACKGROUND]: {
    en: 'Background',
    ro: 'Fundal',
    pl: 'Tło',
    da: 'Baggrund',
    sv: 'Bakgrund',
    es: 'Fondo',
    pt: 'Plano de fundo',
    fr: 'Arrière-plan',
    de: 'Hintergrund',
    nl: 'Achtergrond',
    it: 'Sfondo',
  },
  [VehiclePart.CAR_INSIDE]: {
    en: 'Car Inside',
    ro: 'Interiorul vehiculului',
    pl: 'Wnętrze pojazdu',
    da: 'Bilen indvendigt',
    sv: 'Bilens interiör',
    es: 'Interior del vehículo',
    pt: 'Interior do carro',
    fr: 'Intérieur',
    de: 'Auto innen',
    nl: 'Auto binnen',
    it: 'Interno auto',
  },
  [VehiclePart.DAMAGED_CAR_INSIDE]: {
    en: 'Damaged Car Inside',
    ro: 'Interiorul vehiculului avariat',
    pl: 'Uszkodzenia wewnątrz pojazdu',
    da: 'Beskadiget køretøj indvendigt',
    sv: 'Skadat fordon, interiör',
    es: 'Interior del vehículo dañado',
    pt: 'Interior do carro danificado',
    fr: 'Intérieur endommagé',
    de: 'Beschädigtes Auto innen',
    nl: 'Beschadigde auto binnen',
    it: 'Interno auto danneggiato',
  },
  [VehiclePart.HANDLE_BACK_CENTER]: {
    en: 'Handle Back Center',
    ro: 'Mânerele din spate, zona centrală',
    pl: 'Tyльна środkowa część',
    da: 'Håndtag, bageste midterdør',
    sv: 'Bakre mittkonsol',
    es: 'Parte central trasera de la manija',
    pt: 'Parte Central Traseira da Maçaneta',
    fr: 'Poignée arrière centre',
    de: 'Griff Rückseite Mitte',
    nl: 'Handgreep Terug Midden',
    it: 'Maniglia posteriore centrale',
  },
  [VehiclePart.RIM_BACK_LEFT]: {
    en: 'Back left rim',
    ro: 'Janta spate stânga',
    pl: 'Lewy tylny felg',
    da: 'Bageste venstre fælg',
    sv: 'Bakre vänstra fälgen',
    es: 'Llanta trasera izquierda',
    pt: 'Aro traseiro esquerdo',
    fr: 'Jante arrière gauche',
    de: 'Hintere linke Felge',
    nl: 'Achtervelg links',
    it: 'Rim posteriore sinistro',
  },
  [VehiclePart.RIM_BACK_RIGHT]: {
    en: 'Back right rim',
    ro: 'Janta spate dreapta',
    pl: 'Obręcz tylnego prawego koła',
    da: 'Bageste højre fælg',
    sv: 'Bakre högra fälgen',
    es: 'Llanta trasera derecha',
    pt: 'Aro traseiro direito',
    fr: 'Jante arrière droite',
    de: 'Hintere rechte Felge',
    nl: 'Achtervelg rechts',
    it: 'Rim posteriore destro',
  },
  [VehiclePart.RIM_FRONT_LEFT]: {
    en: 'Front left rim',
    ro: 'Janta din față, partea stângă',
    pl: 'Lewy przedni felg',
    da: 'Forreste venstre fælg',
    sv: 'Fram vänster fälg',
    es: 'Llanta delantera izquierda',
    pt: 'Aro dianteiro esquerdo',
    fr: 'Jante avant gauche',
    de: 'Vordere linke Felge',
    nl: 'Voorvelg links',
    it: 'Rim anteriore sinistro',
  },
  [VehiclePart.RIM_FRONT_RIGHT]: {
    en: 'Front right rim',
    ro: 'Janta față dreapta',
    pl: 'Obręcz przedniego prawego koła',
    da: 'Forreste højre fælg',
    sv: 'Framre högra fälgen',
    es: 'Llanta delantera derecha',
    pt: 'Aro dianteiro direito',
    fr: 'Jante avant droite',
    de: 'Vordere rechte Felge',
    nl: 'Voorvelg rechts',
    it: 'Rim anteriore destro',
  },
  [VehiclePart.INTERIOR]: {
    en: 'Interior',
    ro: 'Interior',
    pl: 'Wnętrze',
    da: 'Indvendigt',
    sv: 'Interiör',
    es: 'Interior',
    pt: 'Interior',
    fr: 'Intérieur',
    de: 'Innenraum',
    nl: 'Interieur',
    it: 'Interni',
  },
};
